// extracted by mini-css-extract-plugin
export var wrapperStyle = "blog_related_articles_section-module--wrapperStyle--0tNQB";